module.exports = __webpack_public_path__ + "img/activate2.c8dba5e5.svg";